import html2pdf from 'html2pdf.js';
import moment from 'moment';

export const getPdfFile = async (domElement: HTMLElement, noticeId: number) => {
  const randomStr = (Math.random() * 99999).toFixed(0).padStart(5, '0');
  const fileName = `${moment().format(
    'YYMMDDhhmmss'
  )}-2-${noticeId}-${randomStr}.pdf`;
  const pdf = await html2pdf()
    .from(domElement)
    .set({
      margin: 10,
      filename: fileName,
      html2canvas: { scale: 2, useCORS: true, logging: true },
      jsPDF: { format: 'a4' },
    })
    .toPdf() // 获取 jsPDF 实例
    .get('pdf'); // 从 jsPDF 实例中提取原始 PDF 数据

  // 生成 Blob
  const blob = pdf.output('blob');
  const file = new File([blob], fileName, { type: 'application/pdf' });
  return { fileName, file };
};
